import React, {Fragment} from "react";
import "../../scss/CustomerIndex.css"
import ToastHelper from "../../utils/ToastHelper";
import AgentService from "../../services/Agent/AgentService";
import SectionHeader from "./SectionHeader";
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import SFXButtonComponent from "../../components/SFXButtonComponent";
import ValidatableObjectComponent from "../../components/ValidatableObjectComponent";
import * as ValidationRule from "../../utils/ValidationRule";
import * as Yup from "yup";
import LoadingSpinnerComponent from "../../components/LoadingSpinnerComponent";

export default class AgentAddressDetailsComponent extends React.Component {

    constructor(props) {
        super(props);
        this.addressValidationConfig = [
            {
                dataField: "streetNumber", dataLabel: "Street Number",
                yup: Yup.string()
                    .required('Street Number is required')
            },
            {
                dataField: "streetName", dataLabel: "Street Name",
                yup: Yup.string()
                    .required('Street Name is required')
            },
            {
                dataField: "suburb", dataLabel: "Suburb",
                yup: Yup.string()
                    .required('Suburb is required')
            },
            {
                dataField: "city", dataLabel: "City",
                yup: Yup.string()
                    .required('City is required')
            },
            {
                dataField: "province",
                dataLabel: "Province",
                selectOptionValueField: "displayName",
                type: "select-province",
                yup: Yup.string()
                    .required('Province is required')
            },
            {
                dataField: "postalCode", dataLabel: "Postal Code",
                yup: ValidationRule.getPostalCodeRule("Postal Code", true)
            }
        ];


        this.viewRef = null;
        this.state = {
            loading: false,
            isPopupOpen: false,
            detailsValid: false
        }
    }

    toggleModal() {
        this.setState({isPopupOpen: !this.state.isPopupOpen, detailsValid: false})
    };

    editSubmit() {
        this.setState({loading: true})
        let newValues = this.viewRef.getValues();
        let newState = {loading: false}
        AgentService.updateAddress(this.props.agentId, newValues).then(response => {
            if (response.streetNumber) {
                newState.loading = false
                newState.isPopupOpen = false
                newState.detailsValid = false;

                ToastHelper.success("Address details updated.");
            } else {
                ToastHelper.formatError(response);
            }
            this.setState(newState, this.props.onRefresh);
        });
    }

    render() {

        let address = this.props.address;
        let fullAddress = address.streetNumber + " " + address.streetName + ", " + address.suburb + " " + address.city + ", " + address.province + ", " + address.postalCode
        return <div>
            <SectionHeader text={"ADDRESS DETAILS"} onEditClick={this.toggleModal.bind(this)} canEdit={this.props.canEdit}/>
            <div>
                {fullAddress}
            </div>
            {this.state.isPopupOpen && this.showModal()}
        </div>

    }

    showModal() {
        return <Fragment>
            <Modal isOpen={this.state.isPopupOpen}
                   className={'modal-primary modal-md'}>
                <ModalHeader toggle={this.toggleModal.bind(this)} canEdit={true}>Edit Address details</ModalHeader>
                <ModalBody>
                    {this.state.loading
                        ? <LoadingSpinnerComponent/>
                        : <ValidatableObjectComponent
                            ref={(ref) => this.viewRef = ref}
                            config={this.addressValidationConfig}
                            defaultValues={this.props.address}
                            readOnly={false}
                            hideCreateFields={false}
                            onValidChanged={(valid) => {
                                this.setState({
                                    detailsValid: valid
                                })
                            }}
                        />}
                </ModalBody>
                <ModalFooter>
                    <SFXButtonComponent className="btn btn-md btn-block btn-primary"
                                        disabled={this.state.loading || !this.state.detailsValid}
                                        onClick={this.editSubmit.bind(this)}>Submit</SFXButtonComponent>{' '}
                </ModalFooter>
            </Modal>
        </Fragment>
    }
}
